import styled from 'styled-components';
import { media, colors, fonts } from 'settings/style';

export const PageShell = styled.div`
  background: #ffffff;
  padding-bottom: 3rem;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  color: ${colors.grey700};
`;

export const PageHeader = styled.header`
  padding: 2.25rem 0 1.25rem;
  border-bottom: 1px solid #eaecf0;
  margin-bottom: 2rem;

  ${media.md`
    padding: 1.5rem 0 1rem;
    margin-bottom: 1.5rem;
  `}
`;

export const PageTitle = styled.h1`
  margin: 0 0 8px;
  font-family: ${fonts.tertiary};
  font-size: 2.25rem;
  color: ${colors.grey900};

  ${media.md`
    font-size: 1.75rem;
  `}
`;

export const EffectiveDate = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  color: #667085;
`;

export const Content = styled.article`
  width: 100%;
  font-size: 1rem;
  line-height: 1.7;

  h2 {
    font-family: ${fonts.tertiary};
    font-size: 1.5rem;
    color: ${colors.grey900};
    margin: 2.25rem 0 0.75rem;
    scroll-margin-top: 5rem;

    ${media.md`
      font-size: 1.25rem;
      margin-top: 1.75rem;
    `}
  }

  h3 {
    font-size: 1.0625rem;
    font-weight: 600;
    color: ${colors.grey900};
    margin: 1.5rem 0 0.5rem;
  }

  p {
    margin: 0 0 1rem;
  }

  ul,
  ol {
    margin: 0 0 1rem;
    padding-left: 1.25rem;
  }

  li {
    margin-bottom: 0.5rem;
  }

  strong {
    color: ${colors.grey900};
    font-weight: 600;
  }

  a {
    color: #1d7fa3;
    text-decoration: underline;

    &:hover {
      color: #145e79;
    }
  }
`;

export const Intro = styled.p`
  font-size: 1.0625rem;
  color: #475467;

  ${media.md`
    font-size: 1rem;
  `}
`;

export const TableOfContents = styled.nav`
  background: #f9fafb;
  border: 1px solid #eaecf0;
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 2rem;

  h2 {
    margin: 0 0 0.75rem;
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #667085;
  }

  ol {
    margin: 0;
    padding-left: 1.125rem;
    columns: 2;
    column-gap: 2rem;

    ${media.xs`
      columns: 1;
    `}
  }

  li {
    margin-bottom: 0.25rem;
    break-inside: avoid;
  }

  a {
    color: ${colors.grey700};
    text-decoration: none;

    &:hover {
      color: ${colors.grey900};
      text-decoration: underline;
    }
  }
`;

export const Callout = styled.div`
  background: #f4f9fb;
  border-left: 3px solid ${colors.primary};
  border-radius: 0 6px 6px 0;
  padding: 1rem 1.25rem;
  margin: 0 0 1.25rem;

  p:last-child {
    margin-bottom: 0;
  }
`;

export const ContactBlock = styled.address`
  font-style: normal;
  line-height: 1.7;
  margin: 0;

  strong {
    display: block;
  }
`;
